import { useState, useEffect } from "react";

import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import useFetch from "Hooks/useFetch.js";
import IsError from "Components/RequestHandler/IsError";

const MainNews = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("news");
      setData(data?.news);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const [selectedCat, setSelectedCat] = useState(null);

  const selectedCatHandler = (cat) => {
    // Toggle the category if clicked again
    setSelectedCat((prevCat) => (prevCat === cat ? null : cat));
  };

  const filteredProjects = selectedCat
    ? data?.filter((project) => project.category === selectedCat)
    : data;

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero
          onHandleSelectedCat={selectedCatHandler}
          selectedCat={selectedCat}
          data={data}
        />
        <Landing data={filteredProjects} />
      </main>
    );
  }
};

export default MainNews;
